import MilestoneList from "../goals/MilestoneList";
// GoalCardList.js
import React from "react";
import { Card, HTMLSelect, Icon } from "@blueprintjs/core";
import Flexbox from "flexbox-react";
import "./MyAssessmentView.css";
import Progress from "../../assets/Progress.svg";
import { Tooltip } from "@blueprintjs/core";
import CurrentUserStore from "../../stores/CurrentUserStore";
import { isGoalProgressSpecialAccount } from "../../utils/goalProgressUtils.js";
import GoalProgressRow from "../goals/GoalProgressRow.js";

const getDescriptionPreview = (description) => {
  if (!description) return "";
  const maxChars = 80;
  if (description.length <= maxChars) return description;
  return `${description.slice(0, maxChars)}... Read more`;
};

const GoalRatingForm = ({
  goalList,
  goalRatings,
  onRatingChange,
  weightage = false,
  ratingLabels = [],
  startRatingValue,
  endRatingValue,
  subGoalsByGoalId,
  openSubGoals,
  toggleSubGoals
}) => {

  if (!goalList || goalList.length === 0) return null;
  const accountId = CurrentUserStore?.activeAccount?.accountId ?? null;
  const useRatingLabels = isGoalProgressSpecialAccount(accountId);
  const fallbackRatingLabels = React.useMemo(
    () => ([
      { label: "Not Met", value: 1 },
      { label: "Partially Met", value: 2 },
      { label: "Met", value: 3 }
    ]),
    []
  );
  return goalList?.map(goal => {
    const subGoals = Array.isArray(goal.sub_goals) ? goal.sub_goals : (subGoalsByGoalId?.[goal.id] || []);
    return (
    <Card key={goal.id} className="assessment-question-card">
      <Flexbox justifyContent="space-between" style={{ width: "100%" }} gap="20px" flexDirection="row" alignItems="center" flexGrow={1} >
        <Flexbox className="question-container" flexGrow={1} flexDirection="column">
          <Flexbox className='push-10-t'>
            <span className="push-10-r" role="img" aria-label="chart">
              <Icon icon="settings" style={{ color: "#137CBD" }} />
            </span>
            <strong style={{ fontSize: "14px", color: "#333", cursor: "pointer" }}>
              {goal.title}
            </strong>
          </Flexbox>
          {goal.cascade_id && (
            <div style={{ fontSize: 12, marginBottom: 8, color: "#667085" }}>
              Cascades from:
              <strong style={{ color: "#0052CC", marginLeft: 4 }}>{goal.cascade_title}</strong>
            </div>
          )}
          {goal.description && (
            <Tooltip
              content={goal.description}
              placement="top"
              popoverClassName="goal-description-tooltip"
            >
              <div className="goal-sub-description">
                {getDescriptionPreview(goal.description)}
              </div>
            </Tooltip>
          )}
          <Flexbox flexDirection="row" gap="16px" className="weitage-progres-row push-10-t"  alignItems="center">
            <Tooltip content={"Progress"} placement="top">
              <img
                src={Progress}
                alt="progress icon"
                style={{ width: 20, height: 20, marginRight: '5px', marginTop: '4px' }}
              />
            </Tooltip>
            <GoalProgressRow goal={goal} subGoals={subGoals} accountId={accountId} />
          </Flexbox>
          <Flexbox flexDirection="row" gap="8px">
            {goal?.file_name && (
              <div style={{ marginTop: 8 }}>
                <a
                  href={goal?.file_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="attached-file-link"
                >
                  <Icon icon="paperclip" size={12} />
                  {goal?.file_name || "Attached File"}
                </a>
              </div>
            )}
          </Flexbox>

        </Flexbox>

        <Flexbox flexGrow={1} className="rating-container" >
          <div >
            <HTMLSelect
              value={goalRatings[goal.id] || ""}
              onChange={e => onRatingChange(goal.id, e.target.value, goal.goal_weight)}
              options={[
                { label: "Select Rating", value: "" },
                { label: "NA", value: -1 },

                ...(
                  useRatingLabels &&
                    (
                      (Array.isArray(ratingLabels) && ratingLabels.length > 0) ||
                      (
                        goal?.goal_rating?.start_range === 1 &&
                        goal?.goal_rating?.end_range === 3
                      )
                    )
                    ? (
                      ratingLabels.length > 0
                        ? ratingLabels
                        : fallbackRatingLabels
                    ).map(rl => ({
                      label: rl.label,
                      value: String(rl.value)
                    }))

                    : goal?.goal_rating?.start_range != null &&
                      goal?.goal_rating?.end_range != null

                      ? Array.from(
                        {
                          length:
                            goal.goal_rating.end_range -
                            goal.goal_rating.start_range +
                            1
                        },
                        (_, i) => {
                          const val =
                            goal.goal_rating.start_range + i;

                          return {
                            label: val.toString(),
                            value: String(val)
                          };
                        }
                      )

                      : startRatingValue != null &&
                        endRatingValue != null

                        ? Array.from(
                          {
                            length:
                              Number(endRatingValue) -
                              Number(startRatingValue) +
                              1
                          },
                          (_, i) => {
                            const val =
                              Number(startRatingValue) + i;

                            return {
                              label: String(val),
                              value: String(val)
                            };
                          }
                        )

                        : []
                )
              ]}
              // options={[
              //   { label: "Select Rating", value: "" },
              //   { label: "NA", value: -1 },

              //   ...(
              //     useRatingLabels &&
              //       Array.isArray(ratingLabels) &&
              //       ratingLabels.length > 0
              //       ? ratingLabels.map(rl => ({
              //         label: rl.label,
              //         value: String(rl.value)
              //       }))
              //       : goal?.goal_rating?.start_range != null &&
              //         goal?.goal_rating?.end_range != null
              //         ? Array.from(
              //           {
              //             length:
              //               goal.goal_rating.end_range -
              //               goal.goal_rating.start_range +
              //               1
              //           },
              //           (_, i) => {
              //             const val =
              //               goal.goal_rating.start_range + i;

              //             return {
              //               label: val.toString(),
              //               value: String(val)
              //             };
              //           }
              //         )
              //         : startRatingValue != null &&
              //           endRatingValue != null
              //           ? Array.from(
              //             {
              //               length: Number(endRatingValue) - Number(startRatingValue) + 1
              //             },
              //             (_, i) => {
              //               const val = Number(startRatingValue) + i;
              //               return {
              //                 label: String(val),
              //                 value: String(val)
              //               };
              //             }
              //           )
              //           : []
              //   )
              // ]}
              style={{ width: "150px" }}
            />
            {!!weightage &&
              <p className="question-weightage">
                Weightage: {goal?.goal_weight &&
                  <strong style={{ fontWeight: 600 }}>{goal.goal_weight || "-"}</strong>}
              </p>
            }
          </div>
        </Flexbox>
      </Flexbox>

      {(() => {
        return (
          <>
            <div
              style={{
                marginTop: 8,
                fontSize: 13,
                color: "#6f5bd7",
                cursor: subGoals.length ? "pointer" : "default",
              }}
              onClick={() => subGoals.length && toggleSubGoals(goal.id)}
            >
              <Icon
                icon={openSubGoals?.[goal.id] ? "chevron-down" : "chevron-right"}
                size={14}
              />
              {subGoals.length} Sub Goals
            </div>

            {subGoals.length > 0 && openSubGoals?.[goal.id] && (
              <div style={{ paddingLeft: 30, marginTop: 10 }}>
                {subGoals.map(sub => (
                  <Card
                    key={sub.id}
                    style={{
                      marginBottom: 10,
                      borderRadius: 8,
                      border: "1px solid #e5e5e5",
                      padding: 12,
                      boxShadow: "none"
                    }}
                  >
                    <div>
                      <b>{sub.title}</b>
                    </div>

                    {sub.description && (
                      <Tooltip
                        content={sub.description}
                        placement="right"
                        popoverClassName="goal-description-tooltip"
                      >
                        <div className="goal-sub-description">
                          {getDescriptionPreview(sub.description)}
                        </div>
                      </Tooltip>
                    )}
                    <Flexbox flexDirection="row" gap="16px" className="weitage-progres-row" alignItems="center">
                      <Tooltip content={"Progress"} placement="top">
                        <img
                          src={Progress}
                          alt="progress icon"
                          style={{ width: 20, height: 20, marginRight: '5px', marginTop: '4px' }}
                        />
                      </Tooltip>
                      <GoalProgressRow goal={sub} accountId={accountId} />
                    </Flexbox>

                    <Flexbox flexDirection="row" gap="8px">
                      {sub?.file_url && (
                        <div>
                          <a href={sub?.file_url} target="_blank" rel="noopener noreferrer" className="attached-file-link">
                            <Icon icon="paperclip" size={12} />
                            {sub?.file_name || "Attached File"}
                          </a>
                        </div>
                      )}
                    </Flexbox>

                    <MilestoneList subGoal={sub} editable={false} />
                  </Card>
                ))}
              </div>
            )}
          </>
        );
      })()}

    </Card>
  );
  });
};

export default GoalRatingForm;
